import { createSelector } from 'reselect';
import { FONT_SETS } from 'ContentUtils/constants/Fonts';
export const getGoogleFonts = state => state.resources.googleFonts.fonts;
export const getGoogleFontsPagination = state => state.resources.googleFonts.googleFontsPagination;
export const getGoogleFontsFetchStatus = state => state.resources.googleFonts.googleFontsRequestStatus;
export const getCustomFontsByAsset = (state, props) => state.resources.googleFonts.customFontsByAsset[props.assetPath] || {};
export const getCustomFonts = state => state.resources.googleFonts.customFonts || {};
export const getSelectedCustomFonts = state => state.resources.googleFonts.selectedCustomFonts;
export const selectedGoogleFonts = state => state.resources.googleFonts.selectedFonts;
export const getCommonGoogleFontResults = state => state.resources.googleFonts.commonFonts;
export const getCommonGoogleFonts = createSelector([getCommonGoogleFontResults], fonts => {
  return fonts.reduce((hash, font) => {
    hash[font.family] = font;
    return hash;
  }, {});
});
export const getCommonFontsFetchStatus = state => state.resources.googleFonts.commonFontsRequestStatus;
export const getOptions = createSelector([getGoogleFonts], fonts => {
  if (!(fonts && Object.keys(fonts))) return [];
  return Object.keys(fonts).map(name => {
    const font = fonts[name];
    return {
      fontSet: FONT_SETS.GOOGLE,
      text: font.family,
      value: font.family
    };
  });
});
export const getCustomFontsByAssetOptions = createSelector([getCustomFontsByAsset], customFonts => {
  if (!(customFonts && Object.keys(customFonts))) return [];
  return Object.keys(customFonts).map(name => {
    const font = customFonts[name];
    return {
      fontSet: FONT_SETS.CUSTOM,
      text: font.family,
      value: font.family
    };
  });
});
export const getCustomFontsOptions = createSelector([getCustomFonts], customFonts => {
  if (!customFonts) return [];
  return Object.keys(customFonts).map(name => {
    const font = customFonts[name];
    return {
      fontSet: FONT_SETS.BRANDING,
      text: font.name,
      value: font.name
    };
  });
});
export const getCustomFontsByAssetFetchStatus = (state, props) => state.resources.googleFonts.customFontsByAssetRequestStatus[props.assetPath];
export const getCustomFontsFetchStatus = state => state.resources.googleFonts.customFontsRequestStatus;
export const getCustomFontFetchStatus = state => state.resources.googleFonts.customFontRequestStatus;
export const getCreateCustomFontRequestStatus = state => state.resources.googleFonts.createCustomFontRequestStatus;
export const getCustomFontToEdit = state => state.resources.googleFonts.customFontToEdit;
export const getEditCustomFontRequestStatus = state => state.resources.googleFonts.editCustomFontRequestStatus;
export const getUploadCustomFontFileRequestStatus = state => state.resources.googleFonts.uploadCustomFontFileRequestStatus;
export const getUploadedCustomFontFilesByName = state => state.resources.googleFonts.uploadedCustomFontFilesByName;
export const getUploadedCustomFontFilesById = state => state.resources.googleFonts.uploadedCustomFontFilesById;
export const getFetchCustomFontFileRequestStatus = state => state.resources.googleFonts.fetchCustomFontFileRequestStatus;
export const getDeleteCustomFontRequestStatus = state => state.resources.googleFonts.deleteCustomFontRequestStatus;
export const getBrandFonts = state => state.resources.googleFonts.brandFonts;
export const getBrandFontsFetchStatus = state => state.resources.googleFonts.brandFontsRequestStatus;
export const getBrandFontOptions = createSelector([getBrandFonts], brandFonts => {
  return brandFonts === null || brandFonts === void 0 ? void 0 : brandFonts.map(brandFont => {
    const {
      fontSet,
      name,
      optionText
    } = brandFont;
    return {
      fontSet,
      text: optionText || name,
      value: name
    };
  });
});